import type { ReactElement } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import TutorialTooltip from './TutorialTooltip';

type Props = {
  href: string;
  className?: string;
  showTutorialTooltip: boolean;
};

function ChangeMealsButton({
  href,
  className,
  showTutorialTooltip,
}: Props): ReactElement {
  const buttonClassName = `c-order__change-meals ${className}`;
  const [showTooltip, setShowTooltip] = useState(showTutorialTooltip);

  return (
    <div className={buttonClassName}>
      <Link className="c-button" to={href}>Change Meals</Link>

      {showTooltip && (
        <TutorialTooltip onClose={() => setShowTooltip(false)} />
      )}
    </div>
  );
}

export default ChangeMealsButton;
